import { Container } from './styled';
import { HEADERS } from './fixtures';
import PropTypes from 'prop-types';
import React from 'react';
import { StatisticsLayout } from 'views/components';
import { Table } from 'mol-ui';
import { clearObject } from 'shared/utils';
import { config } from 'config';
import { statisticsActions } from 'core/Statistics';
import {
    useDispatch,
    useSelector
} from 'hooks';
const { diagnosisLicense } = config;

const DiagnosisGeneral = ({
    tabController
}) => {

    const dispatch = useDispatch();
    const {
        diagnosis,
        loading
    } = useSelector('statistics');

    const onFiltersChange = filters => {
        dispatch(statisticsActions.getStatisticsDiagnosis(clearObject(filters, true)));
    };
    
    return (
        <StatisticsLayout
            filterPatients={ diagnosisLicense }
            loading={ loading }
            tabController={ tabController }
            onFiltersChange={ onFiltersChange }
        >
            <Container>
                <Table
                    config={ HEADERS }
                    data={ diagnosis }
                />
            </Container>
        </StatisticsLayout>
    );
};

DiagnosisGeneral.propTypes = {
    tabController: PropTypes.object
};

export default DiagnosisGeneral;
